export default __webpack_public_path__ + "static/media/203.13b0924c.jpg";